import {
  SET_SELECTED_STATUS_ACTION, SET_SEARCH_TEXT_ACTION, SET_CATALOGO_ACTION, CLEAR_FILTERS_ACTION,
} from './actions.type';
import {
  SET_SELECTED_STATUS, SET_SEARCH_TEXT, SET_CATALOGO, CLEAR_FILTERS,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS_ACTION](context, status) {
    context.commit(SET_SELECTED_STATUS, status);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_CATALOGO_ACTION](context, catalogo) {
    context.commit(SET_CATALOGO, catalogo);
  },
  [CLEAR_FILTERS_ACTION](context) {
    context.commit(CLEAR_FILTERS);
  },
};
